// Buyer consent — required before any seller contact is revealed.
// Persisted per browser in localStorage for 24 hours so the same buyer
// isn't re-prompted on every reveal in one session.

const KEY = "popMarketContactConsent";
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

export function needsConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return true;
    const { acceptedAt } = JSON.parse(raw);
    if (typeof acceptedAt !== "number") return true;
    return Date.now() - acceptedAt > TTL_MS;
  } catch {
    return true;
  }
}

export function recordConsent() {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      acceptedAt: Date.now(),
      version: 1,
    }));
  } catch { /* ignore */ }
}

export function revokeConsent() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
